import React, {useContext} from 'react'
import classes from './Cart.module.css';
import Modal from '../UI/Modal';
import CartItem from './CartItem';
import CartContext from '../../store/CartContext';


export default function Cart(props) {

  const cartCtx = useContext(CartContext)

  const totalAMount = `${cartCtx.totalamount.toFixed(2)}`;

  const hasItems = cartCtx.items.length>0


  // const cartItemRemoveHandler = id => {
    
  // }
  
  // const cartItemAddHandler = (item) => {
  //   cartCtx.addItem(item);

  // }


  const cartItemRemoveHandler = (id) => {
    cartCtx.removeItem(id);
  };

  const cartItemAddHandler = (item) => {
    cartCtx.addItem({...item, amount: 1});
  };

  

    const cartItems =
    <ul className={classes['cart-items']}>  {
    cartCtx.items.map(item => <CartItem key={item.id} 
      name={item.name}
    amount={item.amount}
    price ={item.price} 
    onRemove={cartItemRemoveHandler.bind(null, item.id)}
    onAdd={cartItemAddHandler.bind(null, item)}
    
    /> )
}</ul>
  return (
    <Modal  onClose={props.onClose}>
        {cartItems}
        <div className={classes.total}>
            <span>Total Amount</span>
            <span>{totalAMount}</span>
        </div>
        <div className={classes.actions}>
            <button className={classes['button--alt']} onClick={props.onClose}>Close</button>
            { hasItems && <button className={classes.button}>Order</button>}

        </div>


    </Modal>
  )
}
